import { SlideComponentRadicalWriting } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentRadicalWritingCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentRadicalWriting {
        return {
            id: id,
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 400,
                height: 400,
            },
            type: 'radicalWriting',
            content: {
                code: '',
                locale: '',
                character: '',
            },
        };
    }
}
